import { buildFixedColumnWidths, type ColumnSpec } from "../../../fixed-columns";

/**
 * Exact column recipe from nazare-frontend's own `RUNS_COLS`
 * (`screens/admin/workflows/dashboard.tsx`:
 * `grid-cols-[96px_1fr_minmax(0,2fr)_140px_88px_120px]`) — Status /
 * Workflow / Run ID / Created / Artefacts / Duration. Shared by both the
 * dashboard-embedded runs card (`runs-table.tsx`) and the maximised runs
 * page (`pages/runs.tsx`) so they're defined once, not duplicated.
 */
export const RUNS_COLUMN_SPEC: ColumnSpec[] = [
  { px: 96 },
  { fr: 1 },
  { fr: 2 },
  { px: 140 },
  { px: 88 },
  { px: 120 },
];

export const RUNS_COLUMN_WIDTHS = buildFixedColumnWidths(RUNS_COLUMN_SPEC);
